import styled from 'styled-components';
import {LocalDocumentContentStatus} from "../../../models/local-documents.models";

export const DigitizedDocumentStatusWrapper = styled.div<{ $status: LocalDocumentContentStatus }>`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    border-radius: 16px;
    
    ${({ $status }) => {
        switch ($status) {
            case 'APPROVED':
                return `background: #F0FDF4;`;
            case 'DONE':
                return `background: #F0FDF4;`;
            case 'PROCESSING':
                return `background: #FFF7ED;`;
            case 'TODO':
                return `background: #EFF6FF;`;
            case 'ERROR':
                return `background: #FEF2F2;`;
            case 'ARCHIVED':
                return `background: #F1F5F9;`;
            default:
                return `background: #F1F5F9;`;
        }
    }}
`;

export const StatusDot = styled.span<{ $status: LocalDocumentContentStatus }>`
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;

    ${({ $status }) => {
        switch ($status) {
            case 'APPROVED':
                return `background: #22C55E;`;
            case 'DONE':
                return `background: #22C55E;`;
            case 'PROCESSING': 
                return `background: #FB923C;`;
            case 'TODO':
                return `background: #3B82F6;`;
            case 'ERROR':
                return `background: #F0544F;`;
            case 'ARCHIVED':
                return `background: #94A3B8;`;
            default:
                return `background: #94A3B8;`;
        }
    }}
`;

export const StyledStatusText = styled.span<{ $status: LocalDocumentContentStatus }>`
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;

    ${({ $status }) => {
    switch ($status) {
        case 'APPROVED':
            return `color: #22C55E;`;
        case 'DONE':
            return `color: #22C55E;`;
        case 'PROCESSING':
            return `color: #FB923C;`;
        case 'TODO':
            return `color: #3B82F6;`;
        case 'ERROR':
            return `color: #F0544F;`;
        case 'ARCHIVED':
            return `color: #94A3B8;`;
        default:
            return `color: #94A3B8;`;
    }
}}
`;